<template>
  <div class="con-tab-ejemplo">
    <b>Planned Maintenance</b> - Build,plan and schedule everything needed to
    keep your asset running smoothly
    <br />
    <br />
    <vs-card style="border-radius: 20px">
      <vs-row>
        <vs-spacer></vs-spacer>
        <vs-icon color="#FF8800" icon="print" class="mr-2"></vs-icon>
      </vs-row>
      <br />
      <vs-row>
        <p class="mt-2"><b>PM</b> Template</p>
        <vs-spacer></vs-spacer>
        <vs-checkbox v-model="checkBox1">Include Children Data</vs-checkbox>
      </vs-row>
      <br />
      <div>
        <!-- @selected="handleSelected"
          @dblSelection="doubleSelection" -->
        <vs-table v-model="selected" :data="users">
          <template slot="thead">
            <vs-th> Name </vs-th>
            <vs-th> Schedules </vs-th>
            <vs-th> Assigned To </vs-th>
            <vs-th> Options </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].email" style="width: 30%">
                <vs-row>
                  <a href="#/location/manage" class="mt-2 pt-1">
                    {{ data[indextr].email }}</a
                  >
                  <vs-spacer />
                  <vs-button type="flat" color="#FFFFFF"
                    ><vs-icon
                      size="20px"
                      icon="content_copy"
                      color="#565656"
                    ></vs-icon
                  ></vs-button>
                  <vs-button type="flat" color="#FFFFFF"
                    ><vs-icon size="20px" icon="delete" color="danger"></vs-icon
                  ></vs-button>
                </vs-row>
              </vs-td>

              <vs-td :data="data[indextr].username" c>
                <vs-button type="flat" class="ml-3" color="#FFFFFF"
                  ><vs-icon
                    size="20px"
                    icon="calendar_month"
                    color="danger"
                  ></vs-icon
                ></vs-button>
              </vs-td>

              <vs-td :data="data[indextr].website">
                <a href="#/location/manage" class="ml-3">
                  {{ data[indextr].website }}</a
                >
              </vs-td>

              <vs-td :data="data[indextr].id">
                <vs-row>
                  <vs-icon
                    size="20px"
                    icon="smart_display"
                    color="#565656"
                    class="mr-2"
                    @click="testfocus(data[indextr])"
                    v-b-modal.options1
                  ></vs-icon>

                  <vs-icon
                    size="20px"
                    icon="open_in_new"
                    color="#565656"
                    class="mr-2"
                    v-b-modal.options2
                  ></vs-icon>

                  <vs-icon
                    size="20px"
                    icon="rss_feed"
                    color="#565656"
                    class="mr-2"
                    v-b-modal.options3
                  ></vs-icon>

                  <vs-icon
                    size="20px"
                    icon="qr_code_scanner"
                    color="#565656"
                    class="mr-2"
                    v-b-modal.options4
                  ></vs-icon>

                  <vs-icon
                    size="20px"
                    icon="delete"
                    color="danger"
                    v-b-modal.options5
                  ></vs-icon>
                </vs-row>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <!-- <pre>{{ selected }}</pre> -->
      </div>
      <br />
      <br />
      <BtnAddPMTemplate />
      <br />
      <br />
      <br />
      <vs-divider />
      <br />
      <b>Open PMs</b>
      <br />
      <br />
      <p>You do not have any open PMs for this asset</p>
      <br />
      <vs-divider />
      <br />
      <vs-row>
        <b>Completed PMs</b>
        <vs-spacer />
        <vs-icon
          color="primary"
          icon="cloud_download"
          class="mr-2 mt-2"
        ></vs-icon>
        <vs-input
          class="mr-3"
          icon-after="true"
          icon="search"
          placeholder="What are you looking for?"
          v-model="value1"
        />
      </vs-row>
      <p>There are no Completed PMs for this asset</p>
    </vs-card>
    <b-modal id="options1" centered size="xl" title="">
      <template #modal-title>
        <h3>Upcoming Schedules for: <b>TEST PM Group Feature - Copy</b></h3>
      </template>
      <template #modal-header-close>
        <vs-button icon="close" style="border-radius: 20px" color="red" />
      </template>
      <template>
        <vs-row vs-w="12">
          <vs-col vs-lg="9">
            <p>
              View the next 200 individual upcoming schedules for this template.
              You can delete or restore a deleted schedule for any occurrence.
              Skipped schedules will show in the information column that
              individual schedules will be skipped due to schedules settings.
              Occurrences create the day before or the after a holiday will show
              normally.
            </p>

            <p>
              Sentenance PM Schedules runs every hour to see if it should create
              new schedules. if you just added schedules, or schedules in the
              past, they will be created within the next 60 minutes.
            </p>
          </vs-col>
          <vs-col vs-lg="2"></vs-col>
          <vs-col vs-lg="1">
            <vs-icon icon="print" color="warning"></vs-icon>
          </vs-col>
        </vs-row>
      </template>
      <template #modal-footer>
        <b>There are currently no time based Schedules set for this PM</b>
        <vs-spacer></vs-spacer>
        <vs-button
          color="#32C040"
          style="border-radius: 20px; width: 10%"
          v-b-modal.Add_Field
        >
          Done
        </vs-button>
      </template>
    </b-modal>

    <b-modal id="options2" centered size="xl" title="">
      <template #modal-title>
        <h3>Start <b>Test Group Feature - Copy</b></h3>
      </template>
      <template #modal-header-close>
        <vs-button icon="close" style="border-radius: 20px" color="red" />
      </template>
      <template>
        <p>Due Date</p>
        <datetime
          class="mb-1"
          format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          style="width: 80%"
        />
        <vs-divider />
        <vs-row>
          <vs-spacer />
          <vs-input
            class="mr-3"
            icon-after="true"
            icon="search"
            placeholder="What are you looking for?"
            v-model="value1"
          />
        </vs-row>
        <br />
        <p class="ml-3">Send To</p>
        <vs-row vs-w="12">
          <vs-col vs-lg="6">
            <p>Teams :</p>
            <vs-card
              v-for="(item, index) in 4"
              :key="index"
              actionable
              class="carduser"
            >
              <vs-row>
                <vs-icon icon="groups"></vs-icon>
                <p class="mt-1 ml-3">Chisten Eva</p>
                <vs-spacer></vs-spacer>
                <vs-icon icon="delete" color="red"></vs-icon>
              </vs-row>
            </vs-card>
          </vs-col>
          <vs-col vs-lg="6"
            ><p>Users :</p>
            <vs-card
              v-for="(item, index) in 4"
              :key="index"
              actionable
              class="carduser"
            >
              <vs-row>
                <vs-icon icon="person"></vs-icon>
                <p class="mt-1 ml-3">Chisten Eva</p>
                <vs-spacer></vs-spacer>
                <vs-icon icon="delete" color="red"></vs-icon>
              </vs-row>
            </vs-card>
          </vs-col>
        </vs-row>
      </template>
      <template #modal-footer>
        <vs-spacer></vs-spacer>
        <vs-button
          color="#32C040"
          style="border-radius: 20px; width: 10%"
          v-b-modal.Add_Field
        >
          start
        </vs-button>
      </template>
    </b-modal>

    <b-modal id="options3" centered size="xl" title="">
      <template #modal-title>
        <h3>Update Related PMs</h3>
      </template>
      <template #modal-header-close>
        <vs-button icon="close" style="border-radius: 20px" color="red" />
      </template>
      <template>
        <p>
          This function will take the information in the PM you started 'Update
          Related PMs' from and update from the list of related PMs below.
        </p>
        <vs-divider />
        <p>What information would you like to update?</p>
        <vs-row vs-w="12">
          <vs-col vs-lg="3" v-for="item in 7" :key="item">
            <vs-radio v-model="radios2" vs-value="primary">Name</vs-radio>
            <br />
          </vs-col>
        </vs-row>
        <vs-row>
          <p class="mt-2">PM Description</p>
          <vs-spacer />
          <vs-button
            style="width: 20%; border-radius: 20px"
            v-b-modal.newpmtemplate
            >Create New Relations</vs-button
          >
        </vs-row>
      </template>
      <template #modal-footer>
        <a href="#">View relate PM Templates outside of Building 1</a>
        <vs-spacer></vs-spacer>
        <vs-button
          color="#32C040"
          style="border-radius: 20px; width: 10%"
          v-b-modal.Add_Field
        >
          Done
        </vs-button>
      </template>
    </b-modal>

    <b-modal id="options4" centered size="xl" title="">
      <template #modal-title>
        <h3>Task QR codes - Start or Lookup</h3>
      </template>
      <template #modal-header-close>
        <vs-button icon="close" style="border-radius: 20px" color="red" />
      </template>
      <template>
        <p>
          Use these QR codes to quickly allow your team to start or lookup
          different Tasks for different Assets.
        </p>
      </template>
      <template #modal-footer>
        <b>There are currently no time based Schedules set for this PM</b>
        <vs-spacer></vs-spacer>
        <vs-button
          color="#32C040"
          style="border-radius: 20px; width: 10%"
          v-b-modal.Add_Field
        >
          Done
        </vs-button>
      </template>
    </b-modal>

    <b-modal id="options5" centered size="xl" title="">
      <template #modal-title>
        <h3>Upcoming Schedules for: <b>TEST PM Group Feature - Copy</b></h3>
      </template>
      <template #modal-header-close>
        <vs-button icon="close" style="border-radius: 20px" color="red" />
      </template>
      <template>
        <vs-row vs-w="12">
          <vs-col vs-lg="9">
            <p>
              View the next 200 individual upcoming schedules for this template.
              You can delete or restore a deleted schedule for any occurrence.
              Skipped schedules will show in the information column that
              individual schedules will be skipped due to schedules settings.
              Occurrences create the day before or the after a holiday will show
              normally.
            </p>

            <p>
              Sentenance PM Schedules runs every hour to see if it should create
              new schedules. if you just added schedules, or schedules in the
              past, they will be created within the next 60 minutes.
            </p>
          </vs-col>
          <vs-col vs-lg="2"></vs-col>
          <vs-col vs-lg="1">
            <vs-icon icon="print" color="warning"></vs-icon>
          </vs-col>
        </vs-row>
      </template>
      <template #modal-footer>
        <b>There are currently no time based Schedules set for this PM</b>
        <vs-spacer></vs-spacer>
        <vs-button
          color="#32C040"
          style="border-radius: 20px; width: 10%"
          v-b-modal.Add_Field
        >
          Done
        </vs-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import BtnAddPMTemplate from "../button/BtnAddPMTemplate.vue";
export default {
  components: {
    BtnAddPMTemplate,
  },
  data() {
    return {
      selected: [],
      users: [
        {
          id: 1,
          name: "Leanne Graham",
          username: "Bret",
          email: "Sincere@april.biz",
          website: "hildegard.org",
        },
        {
          id: 2,
          name: "Ervin Howell",
          username: "Antonette",
          email: "Shanna@melissa.tv",
          website: "anastasia.net",
        },
        {
          id: 3,
          name: "Clementine Bauch",
          username: "Samantha",
          email: "Nathan@yesenia.net",
          website: "ramiro.info",
        },
        {
          id: 4,
          name: "Patricia Lebsack",
          username: "Karianne",
          email: "Julianne.OConner@kory.org",
          website: "kale.biz",
        },
        {
          id: 5,
          name: "Chelsey Dietrich",
          username: "Kamren",
          email: "Lucio_Hettinger@annie.ca",
          website: "demarco.info",
        },
        {
          id: 6,
          name: "Mrs. Dennis Schulist",
          username: "Leopoldo_Corkery",
          email: "Karley_Dach@jasper.info",
          website: "ola.org",
        },
      ],
    };
  },
  methods: {
    testfocus(data) {
      console.log(data, "ABC");
    },
    handleSelected(tr) {
      console.log("1");
      this.$vs.notify({
        title: `Selected ${tr.username}`,
        text: `Email: ${tr.email}`,
      });
    },
    doubleSelection(tr) {
      this.$vs.notify({
        title: `Double Selection ${tr.username}`,
        text: `Email: ${tr.email}`,
        color: "success",
      });
    },
  },
};
</script>

<style></style>
